import { matchPath } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

const EXIT_ROUTES = [
	Routing.Portfolio.PortfolioTabs.path(),
	Routing.Portfolio.PortfolioList.path(),
	Routing.Portfolio.DocumentsList.path(),
	Routing.ActivitiesList.path(),
];

export const hasInAppHistory = (
	locationKey: string,
	historyLength: number,
): boolean => locationKey !== "default" && historyLength > 1;

export type BackAction =
	| { type: "native" }
	| { type: "history" }
	| { type: "navigate"; to: string }
	| { type: "none" };

export const getBackFallbackRoute = (pathname: string): string | undefined => {
	const isActivityOrTaskDetail = [
		Routing.ActivityDetail.route,
		Routing.TaskDetail.route,
	].some((route) => matchPath(route, pathname) !== null);

	if (isActivityOrTaskDetail) {
		return Routing.ActivitiesList.path();
	}

	const isPortfolioOrPropertyDetail = [
		Routing.Portfolio.PortfolioDetail.route,
		Routing.Portfolio.PropertyDetail.route,
	].some((route) => matchPath(route, pathname) !== null);

	if (isPortfolioOrPropertyDetail) {
		return Routing.Portfolio.PortfolioList.path();
	}

	return undefined;
};

export const resolveBackAction = ({
	pathname,
	canGoBack,
}: {
	pathname: string;
	canGoBack: boolean;
}): BackAction => {
	const isExitRoute = EXIT_ROUTES.some(
		(route) => matchPath(route, pathname) !== null,
	);

	if (isExitRoute) {
		return { type: "native" };
	}

	if (canGoBack) {
		return { type: "history" };
	}

	const fallback = getBackFallbackRoute(pathname);
	if (fallback === undefined) {
		return { type: "none" };
	}

	return { type: "navigate", to: fallback };
};
